/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './BusinessCreditRiskCta.module.scss';

export const BusinessCreditRiskCta = () => {
  const { t } = useInt();

  return (
    <section className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.panel}>
          <div className={styles.glow} />

          <TitleBlock
            className={styles.titleBlock}
            title={t('Send us a portfolio. We will show you what is already claimed.')}
            description={t(
              'We run your book against the file and return scores, limits, judgments, registered security and group structure, with the filing behind every field.',
            )}
          />

          <div className={styles.actions}>
            <Button type="blue" size="xl" rounded="full" href="/book-a-demo" suffixIcon="arrow-forward">
              {t('Send a portfolio for scoring')}
            </Button>
            <Button type="dark-outline" size="xl" rounded="full" href="/free-trial">
              {t('Pull a credit file free')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
